import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { put, takeLatest, takeLeading } from 'redux-saga/effects'
import { UserModel } from '../models/UserModel'
import { getUserByToken } from './AuthCRUD'
import { AuthModel } from '../models/AuthModel'
import * as cookieManager from '../../../../setup/redux/CookieManager'


export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: 'Login',
  OTPConfirmed: 'OTPConfirmed',
  OTPResend: 'OTPResend',
  Logout: 'Logout',
  UserRequested: 'UserRequested',
  UserLoaded: 'UserLoaded',
  SetHumanVerification: 'SetHumanVerification'
}

const initialAuthState: IAuthState = {
  user: undefined,
  humanVerificationToken: undefined,
  accessToken: cookieManager.getCookie("access_token") ? JSON.parse(cookieManager.getCookie("access_token")!) : undefined
}

export interface IAuthState {
  user?: UserModel
  accessToken?: AuthModel
  humanVerificationToken?: string
}

export const reducer = persistReducer(
  { storage, key: 'kpmrc-auth', whitelist: ['user', 'accessToken'] },
  (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
    switch (action.type) {
      case actionTypes.Login: {
        const accessToken = action.payload?.accessToken
        cookieManager.updateCookie("access_token", JSON.stringify(accessToken), (new Date(accessToken?.expire_in || 0).getTime() - new Date().getTime()))
        return { accessToken, user: undefined }
      }
      case actionTypes.OTPConfirmed: {
        const accessToken = action.payload?.accessToken
        cookieManager.updateCookie("access_token", JSON.stringify(accessToken), (new Date(accessToken?.expire_in || 0).getTime() - new Date().getTime()))
        return { accessToken, user: undefined }
      }
      case actionTypes.OTPResend: {
        const accessToken = action.payload?.accessToken
        cookieManager.updateCookie("access_token", JSON.stringify(accessToken), (new Date(accessToken?.expire_in || 0).getTime() - new Date().getTime()))
        return { accessToken, user: undefined }
      }

      case actionTypes.Logout: {
        cookieManager.removeCookie("access_token")
        return initialAuthState
      }

      case actionTypes.UserRequested: {
        return { ...state, user: undefined }
      }

      case actionTypes.UserLoaded: {
        const user = action.payload?.user
        return { ...state, user }
      }

      case actionTypes.SetHumanVerification: {
        const humanVerificationToken = action.payload?.humanVerificationToken
        return { ...state, humanVerificationToken: humanVerificationToken }
      }

      default:
        return state
    }
  }
)

export const actions = {
  login: (accessToken: AuthModel) => ({ type: actionTypes.Login, payload: { accessToken } }),
  otpResend: (accessToken: AuthModel) => ({ type: actionTypes.OTPResend, payload: { accessToken } }),
  otpConfirmed: (accessToken: AuthModel) => ({ type: actionTypes.OTPConfirmed, payload: { accessToken } }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: () => ({ type: actionTypes.UserRequested }),
  fulfillUser: (user: UserModel) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  refreshToken: (accessToken: AuthModel) => ({ type: actionTypes.OTPConfirmed, payload: { accessToken } }),
  setHumanVerification: (humanVerificationToken: String) => ({ type: actionTypes.SetHumanVerification, payload: { humanVerificationToken } })
}

export function* saga() {
  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const { data: user } = yield getUserByToken()
    yield put(actions.fulfillUser(user.data))
  })
}
